import * as Linking from 'expo-linking';
import { Platform } from 'react-native';
import { appendReturnToAppParam } from '@/lib/auth/web-onboarding-return-to-app';
import { isNativePlatform } from '@/lib/auth/provider-register-url';

const PLANS_PATH = '/subscription/plans';

const PROD_REGISTER_SAMPLE = 'https://controlapag.com.br/register?role=provider';
const DEV_REGISTER_SAMPLE =
  'https://39a3-2804-d84-223d-e200-d4fb-5540-cecf-55d9.ngrok-free.app/register?role=provider';

function getSubscriptionPlansBaseUrl(): string {
  const fromPlansEnv = process.env.EXPO_PUBLIC_SUBSCRIPTION_PLANS_URL?.trim();
  if (fromPlansEnv) return fromPlansEnv;

  const fromRegisterEnv = process.env.EXPO_PUBLIC_PROVIDER_REGISTER_URL?.trim();
  const registerSample =
    fromRegisterEnv || (__DEV__ ? DEV_REGISTER_SAMPLE : PROD_REGISTER_SAMPLE);

  try {
    return `${new URL(registerSample).origin}${PLANS_PATH}`;
  } catch {
    return `https://controlapag.com.br${PLANS_PATH}`;
  }
}

/** URL web de planos (nativo: inclui `return_to_app=1` para voltar ao app após escolher plano). */
export function getSubscriptionPlansWebUrl(): string {
  const base = getSubscriptionPlansBaseUrl();
  return isNativePlatform() ? appendReturnToAppParam(base) : base;
}

/** Abre planos no browser. No iOS retorna false — use `navigateToSubscriptionPlans`. */
export async function openSubscriptionPlansWeb(): Promise<boolean> {
  if (Platform.OS === 'ios') {
    console.warn(
      '[subscription] openSubscriptionPlansWeb não deve ser usado no iOS; use navigateToSubscriptionPlans',
    );
    return false;
  }
  const url = getSubscriptionPlansWebUrl();
  const canOpen = await Linking.canOpenURL(url);
  if (!canOpen) return false;
  await Linking.openURL(url);
  return true;
}

/** iOS uses in-app IAP; Android opens the web; web stays in-app. */
export async function navigateToSubscriptionPlans(router: {
  push: (path: string) => void;
}): Promise<void> {
  // iOS must use in-app purchases (App Store guideline 3.1.1)
  if (Platform.OS === 'ios') {
    router.push('/subscription/plans');
    return;
  }
  // Android: open web checkout (Stripe)
  if (isNativePlatform()) {
    await openSubscriptionPlansWeb();
    return;
  }
  router.push('/subscription/plans');
}
